import type { KeyboardEventHandler, ReactNode } from 'react';
import { Link } from '../../../Link/Link';

export type ResponsiveNavigationItemBaseProps = {
  /** The href to link to. If provided, the nav item acts as a simple link */
  href?: string;
  /** If `true`, the category corresponding to the item is the current page */
  allowNavigation?: boolean;
  children: ReactNode;
  onHover?: () => void;
  onClick?: () => void;
  onNavigate?: () => void;
  onKeyDown?: KeyboardEventHandler<HTMLAnchorElement>;
  /** Additional styles for the `li` element, which by default is a row flex */
  listItemClassNames: string;
  /** Additional styles for the `a` element, which by default uses no decoration, default colors, and is a row flex */
  linkClassNames: string;
};

/**
 * Base component with shared functionality for navigation items
 */
export const ResponsiveNavigationItemBase = ({
  children,
  href,
  allowNavigation,
  listItemClassNames,
  linkClassNames,
  onHover,
  onClick,
  onNavigate,
  onKeyDown,
}: ResponsiveNavigationItemBaseProps) => (
  <li className={`${listItemClassNames} inline-flex`}>
    <Link
      className={`${linkClassNames} after:pointer-none focus-visible:after:standard-focus-outline relative flex flex-1 no-underline outline-none after:absolute after:inset-0 after:-outline-offset-1 after:content-['']`}
      href={href ?? '#'}
      onMouseEnter={() => {
        onHover?.();
      }}
      onKeyDown={onKeyDown}
      onClick={(event) => {
        if (allowNavigation) {
          onNavigate?.();
        } else {
          event.preventDefault();
          onClick?.();
        }
      }}
      prefetch={false}
    >
      {children}
    </Link>
  </li>
);
